export const mediaQueries = {
  xSmall: '@media only screen and (max-width: 576px)',
  small: '@media only screen and (min-width: 576px)',
  medium: '@media only screen and (min-width: 768px)',
  large: '@media only screen and (min-width: 992px)',
  xLarge: '@media only screen and (min-width: 1200px)',
  print: '@media print',
};
